import { PropsWithChildren } from 'react'
import { BrowserRouter } from 'react-router-dom'

import { createApiDownloaderRepository } from '@/Shared/infrastructure'
import { AuthProvider } from '@/Shared/ui/auth'
import { DownloaderProvider } from '@/Shared/ui/downloader'
import { AppConfigProvider } from '@/Shared/ui/language'
import { Loader, LoaderProvider } from '@/Shared/ui/loader'
import { UIProvider } from '@/Shared/ui/navigation'
import { NotificationProvider } from '@/Shared/ui/notifications'
import { Notification } from '@/Shared/ui/notifications/organisms/Notification'
import { createApiUserRepository } from '@/User/infrastructure'
import { UserDataProvider } from '@/User/ui/context'
import { WebTagPermissionsProvider } from '@/User/context'

export const GlobalProviders = ({ children }: PropsWithChildren): JSX.Element => (
  <AppConfigProvider>
    <AuthProvider>
      <BrowserRouter>
        <LoaderProvider>
          <NotificationProvider>
            <UserDataProvider repository={createApiUserRepository()}>
              <WebTagPermissionsProvider>
                <DownloaderProvider repository={createApiDownloaderRepository()}>
                  <UIProvider>{children}
                    <Notification />
                    <Loader />
                  </UIProvider>
                </DownloaderProvider>
              </WebTagPermissionsProvider>
            </UserDataProvider>
          </NotificationProvider>
        </LoaderProvider>
      </BrowserRouter>
    </AuthProvider>
  </AppConfigProvider>
)
